import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

// Slice de ajustes de reservas + turnos. Va junto porque la pestaña
// Ajustes ▸ Reservas los muestra a la vez y se cargan en paralelo.

const initialState = {
  settings: null,        // BookingSettingsDto | null hasta primer fetch
  shifts: [],            // BookingShiftDto[]
  isLoading: false,
  isSaving: false,
  isLoadedSettings: false,
  isLoadedShifts: false,
  error: null,
};

const slice = createSlice({
  name: "bookingSettings",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    startSaving(state) {
      state.isSaving = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.isSaving = false;
      state.error = action.payload;
    },
    setSettings(state, action) {
      state.settings = action.payload;
      state.isLoading = false;
      state.isSaving = false;
      state.isLoadedSettings = true;
    },
    setShifts(state, action) {
      state.shifts = action.payload || [];
      state.isLoading = false;
      state.isLoadedShifts = true;
    },
    upsertShift(state, action) {
      const s = action.payload;
      const idx = state.shifts.findIndex((x) => x.id === s.id);
      if (idx >= 0) state.shifts[idx] = s;
      else state.shifts.push(s);
      state.isSaving = false;
    },
    removeShift(state, action) {
      const id = action.payload;
      state.shifts = state.shifts.filter((s) => s.id !== id);
    },
  },
});

export default slice.reducer;

export function fetchBookingSettings() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.get("/bookingSettings");
      dispatch(slice.actions.setSettings(res.data));
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error cargando ajustes"));
    }
  };
}

export function saveBookingSettings(patch) {
  return async (dispatch) => {
    dispatch(slice.actions.startSaving());
    try {
      const res = await axios.put("/bookingSettings", patch);
      dispatch(slice.actions.setSettings(res.data));
      return res.data;
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error guardando"));
      throw e;
    }
  };
}

export function fetchBookingShifts() {
  return async (dispatch) => {
    try {
      const res = await axios.get("/bookingShift");
      dispatch(slice.actions.setShifts(res.data));
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error cargando turnos"));
    }
  };
}

export function upsertBookingShift(dto) {
  return async (dispatch) => {
    dispatch(slice.actions.startSaving());
    try {
      const res = await axios.post("/bookingShift", dto);
      dispatch(slice.actions.upsertShift(res.data));
      return res.data;
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error guardando turno"));
      throw e;
    }
  };
}

export function deleteBookingShift(id) {
  return async (dispatch) => {
    try {
      await axios.delete(`/bookingShift/${id}`);
      dispatch(slice.actions.removeShift(id));
    } catch (e) {
      dispatch(slice.actions.hasError(e?.message || "Error eliminando turno"));
      throw e;
    }
  };
}
